import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandlerFn,
    HttpRequest,
} from '@angular/common/http';
import { catchError, from, Observable, switchMap, throwError } from 'rxjs';
import { environment } from '../environments/environment';

export const apiInterceptor = (
    request: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    if (request.url.includes('api')) {
        const baseUrl = environment.apiUrl;
        request = request.clone({ url: baseUrl + request.url });
    }

    return next(request).pipe(
        catchError((err) => {
            console.error('API Error:', err);

            // A download asks for a Blob, so a refusal's problem JSON arrives as one too and has
            // to be read before its message can be shown.
            if (err instanceof HttpErrorResponse && err.error instanceof Blob) {
                return from(err.error.text()).pipe(
                    switchMap((text) =>
                        throwError(() => new Error(errorMessage(parse(text))))
                    )
                );
            }

            return throwError(() => new Error(errorMessage(err.error)));
        })
    );
};

/** The validation messages, or the problem's detail, as one string. */
function errorMessage(body: any): string {
    let message = 'An error occurred - Please contact support';

    if (body?.errors) {
        message = '';

        for (const key in body.errors)
            for (const error of body.errors[key]) message += error + '\n';

        message = message.trim();
    } else if (body?.detail) message = body.detail;

    return message;
}

function parse(text: string): unknown {
    try {
        return JSON.parse(text);
    } catch {
        return null;
    }
}
